import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ImportSettingsTable from "./ImportSettingsTable";
import ImportSettingsSkeleton from "../../../BrandSkeletons/ImportSettingsSkeleton";

interface ImportSettingsProps {
  timeFrameSlot?: React.ReactNode;
}
const ImportSettings = ({ timeFrameSlot }: ImportSettingsProps) => {
  const [searchParams] = useSearchParams("");
  const reportType = searchParams.get("report") || "daily_user";

  const brandOverviewFetcherSettingsData = useSelector(
    (state: any) =>
      state.brandConfigurationReport.brandOverviewFetcherSettingsData[
        reportType
      ],
  );

  const loaderForSwitchingTabs = useSelector(
    (state: any) => state.brandConfigurationReport.loaderForSwitchingTabs,
  );

  return (
    <Box px={2} py={1}>
      {/* Header row: title+subtitle on left, time frame on right */}
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Import Settings
          </Typography>

          {!loaderForSwitchingTabs && (
            <Typography variant="body2" color="text.secondary">
              {brandOverviewFetcherSettingsData?.length} Raw Tables
            </Typography>
          )}
        </Box>

        {/* Right: TimeFrameDateRange — fixed width so it doesn't stretch */}
        {timeFrameSlot && (
          <Box m={2} sx={{ width: "280px", flexShrink: 0 }}>
            {timeFrameSlot}
          </Box>
        )}
      </Box>

      {/* Skeleton and table sit below the header row at full width */}
      {loaderForSwitchingTabs ? (
        <ImportSettingsSkeleton />
      ) : (
        <ImportSettingsTable />
      )}
    </Box>
  );
};

export default ImportSettings;
